/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import cs from 'classnames';
import noop from 'lodash/noop';
import { Block, ErrorMessage, ScheduleDay } from '@atoms';
import { CountryField, EventField, TextField } from '@molecules';
import { Form } from '@organisms';
import { SCHEDULE_FIELDS } from './constants';
import EventChannels from './EventChannelsForm';

import s from './styles.module.less';
import { useDaysForSchedule } from '@api/hooks';

const EventScheduleForm = ({ initialValues = {}, error, form, eventId, selectedDay = 0 }) => {
  const [selectedDayIdx, setSelectedDayIdx] = React.useState(selectedDay);

  const { scheduleDays } = useDaysForSchedule({ eventId });

  const fetchedDays = React.useMemo(
    () => scheduleDays?.length && scheduleDays?.map((day) => ({ ...day, channels: [] })),
    [scheduleDays],
  );

  const days = React.useMemo(
    () => (initialValues[SCHEDULE_FIELDS.DAYS.name].length ? initialValues[SCHEDULE_FIELDS.DAYS.name] : fetchedDays),
    [initialValues, fetchedDays],
  );

  const renderDayForm = React.useCallback(
    () =>
      days?.map((day, idx) => {
        const visible = idx === selectedDayIdx;
        return (
          <div style={{ display: visible ? 'unset' : 'none' }} key={`day-${day.day}-button`}>
            <EventChannels initialValues={day} form={form} days={days} dayIdx={idx} />
          </div>
        );
      }),
    [days, selectedDayIdx, form],
  );

  return (
    <>
      <Block spaced>
        <Form form={form} layout="vertical" initialValues={initialValues}>
          {error?.response.status === 404 ? (
            <Block variant="error" spaced>
              Schedule not created for this event yet.
            </Block>
          ) : (
            <ErrorMessage error={error} variant="block" spaced />
          )}
          <EventField
            label={SCHEDULE_FIELDS.EVENT.label}
            {...SCHEDULE_FIELDS.EVENT}
            wrapperCol={{ span: 24 }}
            extra={null}
            disabled
          />
          <CountryField
            rules={[{ required: true, message: 'Country is required' }]}
            wrapperCol={{ span: 24 }}
            name="countryName"
            label="Country:"
            extra={null}
          />
          <TextField {...SCHEDULE_FIELDS.EVENT_FIELDS} style={{ visibility: 'hidden', height: 0, margin: 0 }} />
          <Form.List {...SCHEDULE_FIELDS.DAYS}>{noop}</Form.List>
        </Form>
        {days?.map(({ day, channels }, idx) => {
          const isEmpty = !channels.length;
          return (
            <ScheduleDay
              className={cs(s.dayBrick, { [s.selectedDay]: idx === selectedDayIdx })}
              onClick={() => setSelectedDayIdx(idx)}
              key={`day-${day}-${idx}`}
              title={`Day ${day}`}
              isEmpty={isEmpty}
              value={idx}
            />
          );
        })}

        {renderDayForm()}
      </Block>
    </>
  );
};

EventScheduleForm.useForm = () => Form.useForm(SCHEDULE_FIELDS);

export default EventScheduleForm;
